<template>
  <form-item class="ui-form-item--input" :label="label">
    <input
      class="ui-form-item__control--input"
      v-model="value"
      :placeholder="placeholder"
      :type="type"
      :min="min"
      :max="max"
      :step="step"
      :disabled="disabled"
    />
  </form-item>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import FormItem from '@/vue/ui/form/FormItem.vue'

export default defineComponent({
  name: 'FormInput',
  props: {
    modelValue: String as PropType<string>,
    placeholder: String as PropType<string>,
    label: String as PropType<string>,
    type: {
      type: String as PropType<string>,
      default: 'text',
      validate: (value: string) => ['text', 'number', 'email', 'password'].includes(value),
    },
    min: Number as PropType<number>,
    max: Number as PropType<number>,
    step: Number as PropType<number>,
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  components: {
    FormItem,
  },
  setup(props, { emit }) {
    const value = computed<string>({
      get: () => props.modelValue || '',
      set: (v: string) => emit('update:modelValue', v),
    })
    return { value }
  },
})
</script>

<style lang="stylus">
.ui-form-item__control--input
  display block
  width 100%
  font-family inherit
</style>
